import React from 'react';
import { Col, ColProps } from 'reactstrap';

interface ResponsiveColProps extends Omit<ColProps, 'xs' | 'md'> {
  children: React.ReactNode;
}

/**
 * AuthFormCol - Responsive column for form content
 * Full width on mobile (xs=12), 5 columns on desktop (md=5)
 */
export const AuthFormCol: React.FC<ResponsiveColProps> = ({ children, ...props }) => (
  <Col xs="12" md="5" {...props}>
    {children}
  </Col>
);

/**
 * AuthContentCol - Responsive column for main content area
 * Full width on mobile (xs=12), 7 columns on desktop (md=7)
 */
export const AuthContentCol: React.FC<ResponsiveColProps> = ({ children, ...props }) => (
  <Col xs="12" md="7" {...props}>
    {children}
  </Col>
);

/**
 * AuthWideFormCol - Responsive column for wider form content
 * Full width on mobile (xs=12), 6 columns on desktop (md=6)
 */
export const AuthWideFormCol: React.FC<ResponsiveColProps> = ({ children, ...props }) => (
  <Col xs="12" md="6" {...props}>
    {children}
  </Col>
);